import { TextField } from "@material-ui/core";
import { ChangeEvent, useEffect, useState } from "react";
import useDebounce from "../../hooks/useDebounce";
import SearchIcon from '@material-ui/icons/Search';

interface IProps {
    onSearch: (searchText: string) => void;
    placeholder?:string
}

export function OverviewSearchBox({ onSearch, placeholder }: IProps) {
    const [searchText, setSearchText] = useState("");
    const { debouncedValue } = useDebounce(searchText, 350, true);

    useEffect(() => {
        onSearch(debouncedValue);
    }, [debouncedValue, onSearch]);

    function onChange(ev: ChangeEvent<HTMLInputElement>) {
        const value = ev.target.value;
        setSearchText(value as string);
    }
    return <TextField
        onChange={onChange}
        placeholder={placeholder}
        value={searchText}
        InputProps={{
            startAdornment: <SearchIcon style={placeholder ? { fill:""} : {} } />
        }}
        fullWidth
        variant="outlined"
    />
}